<template>
  <div class="profile-page">
    <router-link class="back-link" to="/home">← 返回主页</router-link>
    <h1>个人中心</h1>
    <div v-if="user" class="info-card">
      <p><span class="label">账号</span>{{ user.account }}</p>
      <p><span class="label">用户 ID</span>{{ user.userId }}</p>
      <p v-if="user.quickCode"><span class="label">快捷码</span>{{ user.quickCode }}</p>
    </div>
    <p v-else class="empty-tip">暂无登录信息</p>
    <button type="button" class="btn-logout" @click="logout">退出登录</button>
  </div>
</template>

<script>
import { getUser, clearUser } from '@/utils/auth'

export default {
  name: 'Profile',
  data () {
    return {
      user: null
    }
  },
  mounted () {
    this.user = getUser()
  },
  methods: {
    logout () {
      if (!window.confirm('确定退出登录？')) return
      clearUser()
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
.profile-page {
  min-height: 100vh;
  padding: 24px;
  background: #e3f2fd;
  color: #1565c0;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei',
    sans-serif;
}

.back-link {
  display: inline-block;
  margin-bottom: 16px;
  color: #0d47a1;
  font-weight: 600;
  text-decoration: none;
}

.back-link:hover {
  text-decoration: underline;
}

h1 {
  margin: 0 0 16px;
  font-size: 22px;
}

.info-card {
  margin-bottom: 24px;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 12px;
  line-height: 1.8;
}

.info-card p {
  margin: 0;
  font-size: 15px;
}

.label {
  display: inline-block;
  min-width: 72px;
  color: #546e7a;
}

.empty-tip {
  margin: 0 0 24px;
  color: #78909c;
}

.btn-logout {
  border: 0;
  border-radius: 999px;
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(180deg, #ef5350 0%, #c62828 100%);
  box-shadow: 0 6px 18px rgba(198, 40, 40, 0.3);
}

.btn-logout:hover {
  filter: brightness(1.05);
}
</style>



// WEBPACK FOOTER //
// src/views/Profile.vue